import React from "react";
import styles from "./About.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

function About() {
	return (
		<section className={cx("about")} id="about">
			<h2 className={cx("title")}>
				About Printer: Smart Print Documents
			</h2>
			<p className={cx("body")}>
				Printer: Smart Print Documents is developed by Starnest JSC.
				<br />
				<br />
				Print documents, photos, Email, Extract text, web pages, and more directly from your mobile device using Wi-Fi printers.
			</p>
		</section>
	);
}

export default About;
